export const DEFAULT_RECOMMENDED_SORTING = { sortBy: 'RECOMMENDED' } as const
